export default class CustomerIO {
  
  constructor() {
    const cioBtns = document.querySelectorAll('.cio-track');
    //console.log('cio 1');
    
    if (cioBtns.length) {
      cioBtns.forEach(cioBtn => {
        this.cioBtn = cioBtn;
        this.cioTrack();
      });
    }
  }
  
  cioTrack() {
    this.cioBtn.addEventListener('click', (event) => {
      const name = event.currentTarget.getAttribute('data-name');
      
      if (typeof _cio !== 'undefined' && _cio.track) {
        if (name == 'twitter') {
          _cio.track('social_click', { button_label: 'Twitter', page: window.location.pathname, source: 'footer'});
        } else if (name == 'linkedin') {
          _cio.track('social_click', { button_label: 'LinkedIn', page: window.location.pathname, source: 'footer'});
        }
      } else {
        console.error('_cio is not defined');
      }
    });
  }
}